// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-simple/accolades-list-simple.component.scss
// module id = 76
// module chunks = 0